import { createContext, useContext, type ReactNode } from "react";

export interface ActiveLocation {
  /** UI id used by the location selector. */
  id: string;
  name: string;
  /** Backend location id — the discriminator for docks/units/etc. */
  locationId: number;
}

const ActiveLocationContext = createContext<ActiveLocation | null>(null);

// The shell selects a location (which also picks the robotics module); views
// read the active location from here to key their data by locationId.
export function ActiveLocationProvider({
  value,
  children,
}: {
  value: ActiveLocation;
  children: ReactNode;
}) {
  return (
    <ActiveLocationContext.Provider value={value}>
      {children}
    </ActiveLocationContext.Provider>
  );
}

export function useActiveLocation(): ActiveLocation {
  const value = useContext(ActiveLocationContext);
  if (!value) {
    throw new Error("useActiveLocation must be used within an ActiveLocationProvider");
  }
  return value;
}
